<app-public-shell-layout [showWorkspaceEntry]="isSignedIn()" [showAssistant]="true">
  @if (loading()) {
    <section class="content-page content-page--state glass-panel" role="status">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      <p>{{ 'COMMON.LOADING' | translate }}</p>
    </section>
  } @else if (error(); as err) {
    <section class="content-page content-page--state glass-panel" role="alert">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <p>{{ err | translate }}</p>
      <a routerLink="/" class="content-page__link">{{ 'COMMON.ACTIONS.BACK_HOME' | translate }}</a>
    </section>
  } @else if (page(); as p) {
    <article class="content-page glass-panel" [class.content-page--contact]="isContactPage">
      <p class="eyebrow">{{ 'PUBLIC_CONTENT.EYEBROW' | translate }}</p>
      <h1>{{ p.title }}</h1>
      <div class="content-page__body">{{ p.content }}</div>

      @if (isContactPage) {
        @if (contact(); as c) {
          <section class="contact-block" [attr.aria-label]="'PUBLIC_CONTENT.CONTACT.ARIA' | translate">
            <a [href]="phoneHref(c.phoneNumber)" class="contact-block__item">
              <i class="pi pi-phone" aria-hidden="true"></i>
              <span class="contact-block__value contact-block__value--ltr contact-block__value--phone" dir="ltr" lang="en">
                <bdi>{{ phoneDisplayNumber(c.phoneNumber) }}</bdi>
              </span>
            </a>
            <a [href]="'mailto:' + c.email" class="contact-block__item">
              <i class="pi pi-envelope" aria-hidden="true"></i>
              <span class="contact-block__value contact-block__value--ltr" dir="ltr" lang="en">{{ c.email }}</span>
            </a>
            <div class="contact-block__item">
              <i class="pi pi-map-marker" aria-hidden="true"></i>
              <span>{{ c.address }}</span>
            </div>
          </section>
        }
      }
    </article>
  }
</app-public-shell-layout>
